import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('stormy_seas', {
  cherry: 'ships_wheel',
  lemon: 'rope_knot',
  orange: 'barrel',
  bell: 'ships_bell',
  star: 'lightning_wild',
  seven: 'cannon',
  gem: 'tricorn_hat',
  scatter: 'thundercloud_scatter',
  money: 'storm_chest',
});

/** Stormy Seas — GENERATED by scaffoldSlot from
 *  content/slots/stormy_seas.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const STORMY_SEAS_THEME: Theme = {
  id: 'stormy_seas',
  name: 'Pirate Plunder',
  palette: {
    accent: 0x5e7c99,
    secondary: 0x8a96a3,
    warm: 0xf2d27a,
    frameFill: 0x161d26,
    bgGradientTop: 0x26313e,
    bgGradientBottom: 0x0c1118,
    dimOverlay: 0x060a0f,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Ship\'s Wheel', glyph: '☸️', tint: 0x9c7a4a, weight: 5, textureAlias: 'stormy_seas:cherry',
        winVideoAlias: 'stormy_seas:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Rope Knot', glyph: '🪢', tint: 0xc9a878, weight: 5, textureAlias: 'stormy_seas:lemon',
        winVideoAlias: 'stormy_seas:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Barrel', glyph: '🛢️', tint: 0xa06a3a, weight: 4, textureAlias: 'stormy_seas:orange',
        winVideoAlias: 'stormy_seas:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Ship\'s Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'stormy_seas:bell',
        winVideoAlias: 'stormy_seas:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Lightning', glyph: '⚡', tint: 0xf2e9b0, weight: 2, textureAlias: 'stormy_seas:star',
        winVideoAlias: 'stormy_seas:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Cannon', glyph: '💣', tint: 0x6a7078, weight: 2, textureAlias: 'stormy_seas:seven',
        winVideoAlias: 'stormy_seas:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Tricorn Hat', glyph: '🎩', tint: 0x4a3a2a, weight: 2.5, textureAlias: 'stormy_seas:gem',
        winVideoAlias: 'stormy_seas:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Thundercloud', glyph: '🌩️', tint: 0x7a8694, weight: 0.5, textureAlias: 'stormy_seas:scatter',
        winVideoAlias: 'stormy_seas:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Storm Chest', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'stormy_seas:money',
        winVideoAlias: 'stormy_seas:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x161d26, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x5e7c99, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x8a96a3, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x5e7c99, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x161d26, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x8a96a3, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x5e7c99, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf2d27a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'stormy_seas:bg', path: 'environment/stormy_seas.png' },
      columnBackground: { alias: 'stormy_seas:column_bg', path: 'reel/stormy_seas_column_bg.png' },
      border: { alias: 'stormy_seas:border', path: 'brand/border_underwater.png' },
    },
  },
};
